import {
  FETCHING_STAGES_REQUEST,
  FETCHING_STAGES_SUCCESS,
  FETCHING_STAGES_FAILURE,
  
  FETCHING_STAGE_REQUEST,
  FETCHING_STAGE_SUCCESS,
  FETCHING_STAGE_FAILURE
} from '../actions/types';
import ResponseService from '../../utils/ResponseService';
import ApplicationError from '../../utils/ApplicationError';

const initialState = {
  stages: [],
  stage: undefined,
  error: ApplicationError.buildDefault(),
  isFetching: false,
  ...ResponseService.defaultPaginationMetaData()
};

const stagesReducer = (state = initialState, action ) => {
  switch(action.type) {
    case FETCHING_STAGES_REQUEST:
      return {...state, isFetching: true }
    case FETCHING_STAGES_SUCCESS:
      return {...state, isFetching: false, 
        stages: action.payload.objects, 
        error: ApplicationError.buildDefault(),
        ...action.payload.paginationData }
        
    case FETCHING_STAGES_FAILURE:
      return {...state, isFetching: false, error: action.payload }
    
    case FETCHING_STAGE_REQUEST:
      return {...state, isFetching: true }
    case FETCHING_STAGE_SUCCESS: 
      return {...state, isFetching: false, stage: action.payload }
    case FETCHING_STAGE_FAILURE:
      return {...state, isFetching: false, error: action.payload }  
    default: 
      return state
  }
}

export default stagesReducer;